import React from 'react';
import { Image } from 'antd';

const PostImages = ({ images = [], title }) => {
  const sortedImages = [...images].sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
  if (!sortedImages.length) return null;
  const layout = sortedImages.length === 1 ? 'single' : [2, 4].includes(sortedImages.length) ? 'two-columns' : 'grid';

  return <div className={`post-detail-images post-detail-images-${layout}`}>
    <Image.PreviewGroup>
      {sortedImages.map((image, index) => <Image key={image.id} src={image.image_url}
        alt={`${title}的配图 ${index + 1}`} loading="lazy" />)}
    </Image.PreviewGroup>
  </div>;
};

export default PostImages;
